<template>
  <b-modal
    id="product-modal"
    ref="destination-advice-accordian-modal-ref"
    hide-footer
    :title="title"
  >
      <div v-if="accordions.length > 1" class="d-flex justify-content-end">
      <b-link
        @click="toggleAll"
        class="cursor expand-collapse-link"
      >
        <span class="d-inline-block text-left" style="width: 90px;">
          {{ expandAll ? 'Collapse All' : 'Expand All' }}
        </span>
        <span>
          <b-icon icon="arrows-expand" class="h5 mb-0" v-if="!expandAll"></b-icon>
          <b-icon icon="arrows-collapse" class="h5 mb-0" v-if="expandAll"></b-icon>
        </span>
      </b-link>
    </div>

      <div
        v-for="(item, index) of accordions"
        :key="index"
      >
        <b-button
          :id="'buttonID-' + index"
          class="product-main"
          :class="{ 'item-active': item.expand }"
          size="sm"
          @click="toggleExpand(index)"
        >
          <div class="item-title">
            <span>{{ item.title }}</span>
          </div>
          <div class="toggle-essential">
            <span v-if="!item.expand">+</span>
            <span v-else>-</span>
          </div>
        </b-button>

        <b-collapse
          :id="'product-supplier' + index"
          v-model="item.expand"
        >
          <div class="item-dropdown accordions">
            <div class="item-dropdown-main accordions-main">
              <div class="extra-info-essentials">
                <div>
                  <p v-html="item.content" />
                </div>
                <div
                  v-if="item.base64image"
                  class="extra-info-img"
                >
                  <img
                    class="non-gallery-img"
                    :src="item.base64image"
                    alt="accordion image"
                  >
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>

    <ServiceErrorMessage
      :error-loading-data="errorLoadingData"
    />
  </b-modal>
</template>

<script>
import ServiceErrorMessage from "@/partials/service-error-message";
export default {
  components: { ServiceErrorMessage },
  data() {
    return {
      errorLoadingData: false,
      title: '',
      accordions: [],
      expandAll: false
    };
  },
  methods: {
    toggleExpand(index) {
      this.accordions[index].expand = !this.accordions[index].expand
      this.$forceUpdate()
    },
    showDestinationAdviceAccordianModal(item) {
      if (!item) {
        this.errorLoadingData = true
        return
      }
      this.accordions = item.accordions
      this.title = item.destinationTitle
      // add a flag for accordions
      this.accordions = this.accordions.map(el => {
        el.expand = false
        return el
      })
      // expand if it's the only one
      if (this.accordions.length === 1) {
        this.accordions[0].expand = true
      }
        this.$refs["destination-advice-accordian-modal-ref"].show();
      },
    toggleAll() {
      this.expandAll = !this.expandAll
      this.accordions.map(item => {
        item.expand = this.expandAll
        return item
      })
      this.$forceUpdate()
    },
    closeModal() {
      this.$refs["destination-advice-accordian-modal-ref"].hide();
    }
  },
};
</script>
<style lang="scss">
.modal-content {
    color: #434343;
  }

  .vtd-modal-content {
    font-weight: 100;
  }

  .vtd-modal-header {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    padding: 20px 30px;
  }

  .vtd-modal-title {
    font-weight: 500;
    font-size: 20px;
  }
.text, .message p{
  text-align:left !important
}
  .vtd-modal-body {
    padding: 0 30px;
  }

  #visa-info-modal___BV_modal_body_ {
    padding: 0;
  }

  .modal-visa-title {
    font-weight: 500;
  }

  .modal-visa-heading {
    font-weight: 500;
  }

  .modal-link a {
    color: #000000;
    font-weight: bold;
    transition: all .2s;
  }

  .modal-link a:hover {
    text-decoration: underline;
  }

  .expand-collapse-link {
    cursor: pointer;
    color: #000000;
    font-weight: bold;
    text-decoration: underline;
  }
  
  .btn-wrap {
    background-color: #f5f5f5;
    padding: 15px 0;
    margin-top: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  @media only screen and (min-width: 700px) {
    .modal-content {
      width: 80%;
      margin: 0 auto;
    }

    .btn-wrap {
      padding: 15px 0;
    }
  }

.message {
  margin-bottom: 20px;
}
</style>
